module.exports = __webpack_public_path__ + "static/media/Apr15-S20.fe34b610.png";